module.exports = __webpack_public_path__ + "img/long02.48ca074b.png";